import { Component } from '@angular/core';

@Component({
  selector: 'app-rcverify',
  templateUrl: './rcverify.component.html',
  styleUrls: ['./rcverify.component.css']
})
export class RcverifyComponent {

  ShowCard:any;
}
